import React, { Component } from 'react'
import Loading from './Loading'
import './Buttons.css'

class ButtonPrimary extends Component {
  render () {
    return (
      <button
        className='btn btn--primary'
        type={this.props.type || 'button'}
        onClick={this.props.onClick}
      >{this.props.loading ? <Loading /> : this.props.label}</button>
    )
  }
}

class ButtonSecondary extends Component {
  render () {
    let className = 'btn btn--secondary'
    if (this.props.sm) {
      className += ' btn--sm'
    }
    if (this.props.warning) {
      className += ' btn--warning'
    }
    return (
      <button
        className={className}
        type={this.props.type || 'button'}
        onClick={this.props.onClick}
      >{this.props.loading ? <Loading /> : this.props.label}</button>
    )
  }
}

export { ButtonPrimary, ButtonSecondary }
